import React from 'react';
import { BookOpen, Package, Star, Tractor } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <BookOpen className="w-5 h-5 text-[#d4af37]" data-id="element-312" />,
    text: '4 Tomos principales'
  }, {
    icon: <Package className="w-5 h-5 text-[#d4af37]" data-id="element-313" />,
    text: '12 Libros especializados'
  }, {
    icon: <Tractor className="w-5 h-5 text-[#d4af37]" data-id="element-314" />,
    text: '4 Cuadernos de actividades'
  }, {
    icon: <Star className="w-5 h-5 text-[#d4af37] fill-[#d4af37]" data-id="element-315" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-[#122618] border-y border-[#2c4c3b] py-6" data-id="element-316">
      <div className="container mx-auto px-4" data-id="element-317">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-318">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-[#fdfbf7]" data-id="element-319">
              {stat.icon}
              <span data-id="element-320">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}